module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.176 0 0 7.178 0 16s7.176 16 16 16 16-7.178 16-16S24.824 0 16 0zm0 20c1.15 0 2.226-.478 2.954-1.312s1.99-.918 2.82-.196c.834.724.922 1.988.196 2.82C20.482 23.02 18.306 24 16 24c-4.412 0-8-3.59-8-8s3.588-8 8-8c2.306 0 4.482.98 5.968 2.688a1.999 1.999 0 1 1-3.016 2.624C18.226 12.478 17.15 12 16 12c-2.206 0-4 1.792-4 4s1.794 4 4 4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/copyright-1.js
// module id = 1092
// module chunks = 14